import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../helpers/fetch-wrapper";

/* Create slice */
const name = "errorLog";
const initialState = createInitialState();
const extraActions = createExtraActions();
const slice = createSlice({ name, initialState });

/* Exports */
export const errorLogActions = { ...slice.actions, ...extraActions };
export const errorLogReducer = slice.reducer;

/* Implementation */
function createInitialState() {
  return {
    value: null,
  };
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}`;

  return {
    logClientError: logClientError(),
  };

  /* Send caught client side errors to the backend */
  function logClientError() {
    return createAsyncThunk(
      `${name}/logClientError`,
      async (request, { dispatch }) => {
        const result = await fetchWrapper.post(
          `${baseUrl}/log-client-error`,
          request
        );
        return result;
      }
    );
  }
}
